<template>
  <List :mapState="'adminUsers'" :showbtn='false' :btndel='false' :allDispatch="'adminUsersDel'"></List>
</template>
<script>
import List from '@/components/modules/base/list.vue'
export default {
  name: 'Lists',
  components: {
    List
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modules/admin/users_del/list.vue